import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Job details\n          ")
], -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
import { Input, Textarea } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'jobDetails',
    props: {
        formData: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const amount = Input('How many positions are you recruiting for?', 'amount', 'text', props.disableForm, props.formData.numberOfPositions);
        const type = Input('What employee type are you recruiting? ', 'type', 'text', props.disableForm, props.formData.employeeType);
        const location = Textarea('Role Location (Site):', 'location', props.disableForm, props.formData.roleLocationSite);
        const location_postcode = Textarea('Role Location (Postcode):', 'location_postcode', props.disableForm, props.formData.roleLocationPostcode);
        const contract_type = Input('What is the employment contract for this role?', 'contract_type', 'text', props.disableForm, props.formData.employmentContract);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(amount) }, null, 8, _hoisted_5),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(type) }, null, 8, _hoisted_6),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(location) }, null, 8, _hoisted_7),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(location_postcode) }, null, 8, _hoisted_8),
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(contract_type) }, null, 8, _hoisted_9)
                    ])
                ])
            ]));
        };
    }
});
